<template>
  <div id="app">
    <navbar />
    <hero />
    <introduction />
    <process />
    <team />
    <!-- <open-source /> -->
    <!-- <clients /> -->
    <!-- <stack /> -->
    <!-- <services /> -->
    <contact />
  </div>
</template>

<script>
import Navbar from './components/Header/Navbar'
import Hero from './components/Header/Hero'
import Introduction from './components/Introduction'
import Process from './components/Process'
import Team from './components/Team'
// import OpenSource from './components/OpenSource'
// import Services from './components/Services'
import Contact from './components/Contact'

export default {
  name: 'App',
  components: {
    Navbar,
    Hero,
    Introduction,
    Process,
    Team,
    // OpenSource,
    // Services,
    Contact
  }
}
</script>

<style>
@font-face {
  font-family: 'OpenSans-Regular';
  src: url('./assets/fonts/OpenSans-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'OpenSans-Bold';
  src: url('./assets/fonts/OpenSans-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}

body {
  margin: 0;
  font-family: 'OpenSans-Regular', Helvetica, sans-serif;
}

#app {
  text-align: center;
  color: #030303;
  margin-top: 0px;
  padding: 2em 0 0;
}

h1 {
  padding: 1em 0 0 0;
}

h1.title {
  padding: 1em 0 0;
}

h2 {
  padding: 2em 0 0 0;
}

blockquote.subtitle {
  padding: 2em 0;
}

section {
  display: block;
}

body {
  @media (max-width: 600px) {
    margin: 0;
  }
}

* {
  user-select: none;
}

p, b {
  user-select: text;
}

</style>
